import React, { Component } from "react";
import db from "../../api/db";
import moment from "moment";
import classNames from "classnames";

class Log extends Component {
  constructor(props) {
    super(props);

    this.state = {
      log: []
    };
  }

  componentDidMount() {
    this.searchQuery();
  }

  searchQuery() {
    db.query("log", { limit: 100 }).then(response => {
      this.setState({
        log: response.data
      });
    });
  }

  render() {
    const date_format = "HH:mm DD.MM YYYY";

    return (
      <div className="main-container">
        <div className="grid-x">
          <div className="medium-9 cell">
            <div className="primary-content">
              <div className="inner">
                <h3>Logg</h3>
                <table>
                  <thead>
                    <tr>
                      <th>Tid</th>
                      <th>Type</th>
                      <th>Modul</th>
                      <th>Melding</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.log.map((item, i) => (
                      <React.Fragment key={item.id}>
                        <tr className="spacer"></tr>
                        <tr className={classNames(item.type, { odd: i % 2 })}>
                          <td>{moment.unix(item.date).format(date_format)}</td>
                          <td>{item.type}</td>
                          <td>{item.category}</td>
                          <td>{item.message}</td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="medium-3 cell">
            <div className="sidebar-holder"></div>
          </div>
        </div>
      </div>
    );
  }
}

export default Log;
